import React, { useState, useEffect, useCallback } from "react";
import { useMutation } from "@apollo/client";

import { GET_DOWNLOAD_INFO } from "./mutations";
import { trackDownload } from "./helpers";
import { trackPhotoDownload } from "core/trackEvent";

const usePhotoDownload = ({
    downloadTier,
    photoId,
    client = null, // optional
}) => {
    const [isStarted, setIsStarted] = useState(false);
    const [isComplete, setIsComplete] = useState(false);
    const [fetchDownloadInfo, { data }] = useMutation(GET_DOWNLOAD_INFO, {
        variables: {
            downloadTier,
            photoId,
        },
        client,
    });

    useEffect(() => {
        if (!!data) {
            // Download the file now that we have the URL
            if (data?.downloadPhoto?.downloadUrl) {
                window.location = data.downloadPhoto.downloadUrl;
            } else {
                console.error(
                    `Unable to download photo. Error: ${data?.downloadPhoto?.errors}`,
                );
            }
            setIsComplete(true);
        }
    }, [data]);

    const startDownload = useCallback(() => {
        fetchDownloadInfo();
        setIsStarted(true);
        setIsComplete(false); // reset in case they're downloading again
        trackDownload({ downloadType: downloadTier, photoId });
        trackPhotoDownload();
    }, [downloadTier, photoId]);

    return {
        startDownload,
        isStarted,
        isComplete,
    };
};

export default usePhotoDownload;
